
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"346","height":"213","viewBox":"0 0 346 213","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M267.9 118.5h19L280 85.3l-12.1 33.2z"}}),_c('path',{attrs:{"d":"M334.2 0H11.5C5.1 0 0 5.1 0 11.3v189.8c0 6.3 5.2 11.3 11.5 11.3h322.7c6.4 0 11.5-5.1 11.5-11.3V11.3c0-6.2-5.1-11.3-11.5-11.3zM75.5 150.7L55.4 73.5c-.2-.1-.4-.3-.7-.4-.1 0-.2-.1-.2-.1-.5-.3-.9-.5-1.4-.8-.5-.3-.9-.5-1.4-.8-.1-.1-.2-.1-.3-.2-.4-.2-.7-.4-1-.6-.2-.1-.3-.2-.5-.2-.3-.1-.6-.3-.9-.4-.2-.1-.3-.2-.5-.2-.3-.1-.6-.3-.8-.4-.2-.1-.3-.1-.5-.2-.4-.2-.8-.4-1.1-.5-.2-.1-.4-.2-.7-.3-.2-.1-.3-.2-.5-.2-.2-.1-.5-.2-.7-.3-.1-.1-.3-.1-.4-.2-.2-.1-.5-.2-.7-.3-.1 0-.1-.1-.2-.1-6.9-2.8-11.6-3.8-11.6-3.8l.4-1.5h36.4c3.6 0 6 1 7.6 2.3 3 2.4 3.4 5.7 3.4 5.7l6.9 35.5.9 4.4 2.6 13.2 22-61.1h24.9l-36.8 88.8-24.1-.1zm55.4 0l14.5-88.8h23.1l-14.4 88.8h-23.2zm63.4 1.6c-15.8 0-26.1-5-26.1-5l3.4-19.9c9.5 7.6 38.2 9.8 38.2-2.3 0-12.1-32-12.3-32-35.3 0-24.4 27.3-29.4 38.7-29.4 10.6 0 20.8 3.9 20.8 3.9L234 83.4c-9.9-5.5-32.4-6.7-32.4 3.3s32.3 12.2 32.3 35.3c0 22.1-23.8 30.3-39.6 30.3zm99-1.6l-2.7-13.2h-29.4l-4.8 13.2h-24.1l34.5-82.2s2.1-6.6 10.7-6.6H296l18.5 88.8h-21.2z"}})])
          )
        }
      }
    